import { useEffect } from "react";
import { useHistory, useLocation, } from "react-router-dom";
import axios from "axios";
import { tokenDecode } from "../../utils/helper";

const ProtectedRoute = ({ children }: any) => {
    const history = useHistory();
    const location = useLocation();
    const search = useLocation().search;
    const tk_access = new URLSearchParams(search).get('tk_access');

    // const token: any = localStorage.getItem("us_st_d");
    // const TokenChecker = async () => {
    //     try {
    //         const { data } = await axios({
    //             url: "/login/refresh",
    //             method: "POST",
    //             headers: {
    //                 Authorization: `Bearer ${token}`
    //             }
    //         });
    //         localStorage.setItem("isLogedIn", data.refreshToken);
    //     } catch (error) {
    //         localStorage.removeItem("isLogedIn");
    //     }
    // }
    useEffect(() => {
        //   TokenChecker();
    }, []);
    const keyV = location.pathname.split("/")[1];
    try {
        const decoded: any = tokenDecode(tk_access);
        const { data } = decoded;
        const { permission: { category, order, product, role, seller, tax, user, location } } = data;
        console.log("hhhh", decoded);

        if (decoded) {
            // if (isAdmin === "true") {
            //     return children;
            // }
            switch (keyV) {
                case "":
                    return children;
                case "dashboard":
                    return children;
                case "addseller":
                    return seller.write ? children : history.push("/")
                case "sellerlist":
                    return seller.read ? children : history.push("/");
                case "tax":
                    return tax.write ? children : history.push("/");
                case "updateseller":
                    return seller.update ? children : history.push("/");
                case "roles":
                    return role.write ? children : history.push("/")
                case "adduser":
                    return user.write ? children : history.push("/");
                case "updateuser":
                    return user.update ? children : history.push("/");
                case "userlist":
                    return user.read ? children : history.push("/");
                case "category":
                    return category.write ? children : history.push("/");
                case "product":
                    return product.write ? children : history.push("/");
                case "productlist":
                    return product.read ? children : history.push("/");
                case "orderlist":
                    return order.read ? children : history.push("/");
                case "orderdetails":
                    return order.read ? children : history.push("/");
                case "transaction":
                    return order.read ? children : history.push("/");
                case "location":
                    return location.read ? children : history.push("/");
                case "profile":
                    return children;
                case "logs":
                    return children;
                case "shopdetails":
                    return children;
                case "brand":
                    return children;
                case "dynamic":
                    return children;
                case "dynamicattribute":
                    return children;
                case "addattribute":
                    return children;
                case "masterproductlist":
                    return children;
                case "sellernonapprovedproducts":
                    return children;
                case "nonapprovedproducts":
                    return children;
                case "nonapprovedproduct":
                    return children;
                case "mastercatalog":
                    return children;
                case "completedorders":
                    return children;
                case "canceledorders":
                    return children;
                case "returnedorders":
                    return children;
                case "ordercompleteinfo":
                    return children;
                    
                default:
                    return history.push("/");
            }

        } else {
            console.log("no");
            switch (keyV) {
                case "forget-password":
                    return children;
                case "reset-password":
                    return children;
                default:
                    return history.push("/");
            }
        }
    } catch (error) {
        console.log("this erro -->", error);

        switch (keyV) {
            case "forget-password":
                return children;
            case "reset-password":
                return children;
            case "test":
                return children;
            default:
                return history.push("/");
        }
    }
}


export default ProtectedRoute;
